export default "__VITE_ASSET__CNZ8yQ35__"